import { HawkerUserRepo } from 'ehawker/src/data/repositories/HawkerUserRepo';

/**
 * List of data to be fetched regularly
 */
export async function fetchData() {
  if (!(await HawkerUserRepo.getUser())) return;
  return Promise.all([]);
}
